export const ADVANCED_COMPOSITOR_CONSTANTS = {
    ERRORS: {
        WEBGPU_INIT_FAILED: 'WebGPU Init Failed',
        LOAD_IMAGE_FAILED: 'Load Image Failed',
        EXECUTION_FAILED: 'Execution Failed'
    },
    DEFAULTS: {
        GLOBAL_OPACITY: 1.0,
        BACKGROUND_COLOR: [0, 0, 0, 1] as [number, number, number, number]
    }
}
